var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProjectOpportunityList',{attrs:{"project":_vm.project}})
}
var staticRenderFns = []

export { render, staticRenderFns }